let now = new Date()
export default {
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
  /**
   * @description api请求基础路径
   */
  publicPath: {
    dev: {
      QWZ:'http://192.168.1.21:8960/',
      crm: 'https://authdevapi.g-parts.cn/',
      // crm: 'http://192.168.0.107:5000/',
      wss: 'https://wssdevapi.g-parts.cn/',
      // wss: 'http://192.168.0.135:5000/',
      wsss: 'http://192.168.0.118:5000/',
      // wsss: 'http://192.168.0.118:5000/',
      zhx: 'http://192.168.0.103:5000/', // 张辉星
      xr: 'http://192.168.0.129:5000/',
      // StoreName: 'http://192.168.0.129:5000/',
      StoreName: 'http://192.168.0.135:5000/', //129
      hl: 'http://192.168.0.125:5000/', //何吕
      kya: 'http://192.168.0.124:5000/', //小柯
      zsy: 'http://192.168.0.135:5000/', // 郑思源
      upload: 'https://authdevapi.g-parts.cn/oss/file/upload?os=oms&isRw=rw',
      oss: 'https://authdevapi.g-parts.cn/oss/auth',
      ztka: 'https://epctestapi.g-parts.cn',
      ztka1:'https://epctest.g-parts.cn',
    },
    test: {
      crm: 'https://authtestapi.g-parts.cn/',
      wss: 'https://wsstestapi.g-parts.cn/',
      zsy: 'http://192.168.0.104:5000/',
      upload: 'https://authdevapi.g-parts.cn/oss/file/upload?os=oms&isRw=rw/',
      oss: 'https://authtestapi.g-parts.cn/oss/auth',
      ztka: 'https://epctestapi.g-parts.cn',
      ztka1:'https://epctest.g-parts.cn',
    },
    pro: {
      crm: 'https://crmapi.g-part.cn/',
      wss: 'https://wssapi.g-part.cn/',
      upload: 'https://crmapi.g-part.cn/',
      oss: 'https://crmapi.g-part.cn/oss/auth',
      ztka: 'https://epcapi.g-part.cn',
      ztka1:'https://epc.g-part.cn', // 跳转极准的页面地址
    },
    uat: {
      crm: 'https://authuatapi.g-parts.cn/',
      wss: 'https://wssuatapi.g-parts.cn/',
      upload: 'https://authuatapi.g-parts.cn/oss/file/upload?os=oms&isRw=rw/',
      oss: 'https://authuatapi.g-parts.cn/oss/auth',
      ztka: 'https://epcuatapi.g-parts.cn',
      ztka1:'https://epcuat.g-parts.cn',
    }
  },
  homeName: 'home',
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: false
}
